import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, TimePicker, message, Row, Col } from 'antd';
import axiosInstance from '../../utils/axios';
import dayjs from 'dayjs';

const TimeSlotModal = ({ open, setOpen, timeslots, setTimeslots, selectedId }) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [selectedItem, setSelectedItem] = useState(null);

	useEffect(() => {
		if (open) {
			if (selectedId !== null) {
				const item = timeslots.find(p => p.id === selectedId);
				setSelectedItem(item);
				if (item) {
					form.setFieldsValue({
						title: item.title || '',
						start_time: dayjs(item.start_time, 'HH:mm:ss'),
						end_time: dayjs(item.end_time, 'HH:mm:ss'),
					});
				}
			} else {
				setSelectedItem(null);
				form.resetFields();
			}
		}
	}, [open, selectedId, timeslots]);

	const handleCancel = () => {
		setOpen(false);
		form.resetFields();
		setSelectedItem(null);
	};

	const handleFinish = async (values) => {
		setLoading(true);

		const payload = {
			title: values.title,
			start_time: values.start_time.format('HH:mm:ss'),
			end_time: values.end_time.format('HH:mm:ss'),
		};

		try {
			let response;
			if (selectedItem) {
				response = await axiosInstance.patch(`core/timeslot/${selectedItem.id}/`, payload);
				setTimeslots(prev =>
					prev.map(p => (p.id === selectedItem.id ? response.data : p))
				);
				message.success("Timeslot updated successfully!");
			} else {
				response = await axiosInstance.post(`core/timeslot/`, payload);
				setTimeslots(prev => [...prev, response.data]);
				message.success("Timeslot added successfully!");
			}

			form.resetFields();
			setOpen(false);
		} catch (error) {
			message.error("Something went wrong");
		} finally {
			setLoading(false);
		}
	};

	return (
		<Modal
			title={selectedItem ? "Edit Time Slot" : "Add New Time Slot"}
			open={open}
			onCancel={handleCancel}
			destroyOnClose
			okButtonProps={{
				autoFocus: true,
				htmlType: 'submit',
				loading: loading,
				disabled: loading,
			}}
			onOk={() => form.submit()}
		>
			<Form
				layout="vertical"
				form={form}
				name="timeslot_form"
				onFinish={handleFinish}
			>
				<Form.Item
					label="Title"
					name="title"
				>
					<Input placeholder="Eg: Matinee" />
				</Form.Item>
				<Row gutter={[16,16]}>
					<Col xs={24} sm={24} md={12}>
						<Form.Item
							label="Start Time"
							name="start_time"
							rules={[{ required: true, message: 'Please select start time' }]}
						>
							<TimePicker format="HH:mm" />
						</Form.Item>
					</Col>
					<Col xs={24} sm={24} md={12}>
						<Form.Item
							label="End Time"
							name="end_time"
							rules={[{ required: true, message: 'Please select end time' }]}
						>
							<TimePicker format="HH:mm" />
						</Form.Item>
					</Col>
				</Row>
			</Form>
		</Modal>
	);
};

export default TimeSlotModal;
